module.exports = __webpack_public_path__ + "img/inactive-archie.210fa629.svg";